// extracted by mini-css-extract-plugin
module.exports = {"News":"News--3k6Yj"};